module.exports = __webpack_public_path__ + "r-v3/img/ml_05_00.e7aa1fa7.jpg";